import { useTranslation } from 'react-i18next';
import styles from './app-evaluation-start.module.scss';

export type MissingLineProps = { items: string[] };

const MissingLine = ({ items }: MissingLineProps) => {
  const [t] = useTranslation('evaluations');
  if (!items.length) return null;
  return (
    <p className={styles.hint}>
      {t('quick.missingLead', 'För att skicka: {{list}}.', { list: items.join(', ') })}
    </p>
  );
};

export default MissingLine;
